import { Component, OnInit,  Renderer2 } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { ActivatedRoute, Router} from "@angular/router";
import { Md5 } from 'ts-md5//dist/md5';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {
  private renderer: Renderer2;

  smsotp: any;
  emailotp: any;
  userId !: any;
  isOtpMode = true;
  respData: any;
  data !: any;
  pwd !: any;
  cnfrmpwd !: any;
  constructor(private fswService: FswService, private route: ActivatedRoute, private router: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.userId = params['userId']; // (+) converts string 'id' to a number
    });
  //   this.renderer.addClass(
  //     document.querySelector('app-root'),
  //     'login-page'
  // );
  }
  checkOtp() {
    debugger
    if (this.emailotp != undefined || this.smsotp != undefined) {
      this.data =
      {
        "userId": this.userId,
        "otp": this.emailotp+this.smsotp
      }
      this.fswService.checkOtp(this.data)
        .subscribe(res => {
          debugger
          this.respData = res;
          if (this.respData.statusCode == '200' || this.respData.message == "Valid") {
            this.isOtpMode = false;
          }
          else {
            this.toastr.error("Please Enter Correct OTP")
            //alert('Please Enter Correct OTP...');
          }

        });
    }
  }
  chngPswrd() {
    debugger
    var str = new String(this.pwd);
    var len = str.length;
    var pattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$");
    if (!this.pwd) {
      alert('Enter Password...');
      return;
    }
    else if (len < 6) {
     // alert('Minimum 6 digit Required...');
      this.toastr.error("Minimum 6 digit Required...")
      return;
    }
    // if (!pattern.test(this.pwd)) {
    //   //alert('Password should contain Uppercase, Lowercase, Special characters and Numeric values...');
    //   this.toastr.error("Password should contain Uppercase, Lowercase, Special characters and Numeric values...")
    //   return;
    // }
    else if (!this.cnfrmpwd) {
      alert('Enter Confirm Password...');
      return;
    }
    else if (this.pwd != this.cnfrmpwd) {
      this.toastr.error("Password and Confirm Password should match...")
      //alert('Password and Confirm Password should match...');
      return;
    }
    else if ((this.pwd != undefined) && (this.cnfrmpwd != undefined) && (this.pwd == this.cnfrmpwd)) {
      //let password = Md5.hashStr(this.pwd);
      let password = this.pwd;
      this.data =
      {
        "userId": this.userId,
        "password": password
      }
      this.fswService.updatePassword(this.data)
        .subscribe(res => {
          debugger
          this.toastr.success("Password updated successfully!!");
          this.router.navigate(['/login']);

        });
    }
  }


  

}
